import { Entries } from 'types';

export enum SelectorsEnum {
    Gender = 'gender',
    Age = 'age',
    Clothes = 'clothes',
    Background = 'background',
}

export enum Gender {
    Any = 'ANY',
    Male = 'MALE',
    Female = 'FEMALE',
}

export enum Age {
    Any = 'ANY',
    From18To24 = 'FROM_18_TO_24',
    From25To39 = 'FROM_25_TO_39',
    From40To59 = 'FROM_40_TO_59',
    From60 = 'FROM_60',
}

export enum Colors {
    Random = 'RANDOM',
    Green = 'GREEN',
    Blue = 'BLUE',
    Black = 'BLACK',
    Red = 'RED',
    Pink = 'PINK',
    Brown = 'BROWN',
    Violet = 'VIOLET',
    Gray = 'GRAY',
    White = 'WHITE',
}

export const GENDER = Object.values(Gender);
export const AGE = Object.values(Age);
export const COLORS = Object.values(Colors);

export const SELECTORS_VALUES = {
    [SelectorsEnum.Age]: AGE,
    [SelectorsEnum.Gender]: GENDER,
    [SelectorsEnum.Clothes]: COLORS,
    [SelectorsEnum.Background]: COLORS,
} as Record<SelectorsEnum, Array<Gender | Age | Colors>>;

const BASE_KEY = 'AdCreate.AdForm.BannerImg.generation.modal.selectors.';

type TranslationMapKey = Age | Gender | Colors;

const createTitlesTranslationMap = () =>
    (Object.keys(SELECTORS_VALUES) as SelectorsEnum[]).reduce((result, key) => {
        result[key] = `${BASE_KEY}${key}`;
        return result;
    }, {} as Record<SelectorsEnum, string>);

const createOptionsTranslationMap = () =>
    (Object.entries(SELECTORS_VALUES) as Entries<typeof SELECTORS_VALUES>).reduce((result, [key, translations]) => {
        const isColorsTranslationKey = key === SelectorsEnum.Clothes || key === SelectorsEnum.Background;
        result[key] = translations.reduce((translationMap, translationKey) => {
            translationMap[translationKey] = `${BASE_KEY}${isColorsTranslationKey ? 'colors' : key}.${translationKey}`;
            return translationMap;
        }, {} as Record<TranslationMapKey, string>);
        return result;
    }, {} as Record<SelectorsEnum, Record<TranslationMapKey, string>>);

export const GENERATION_SELECTORS_OPTIONS_TRANSLATIONS_MAP = createOptionsTranslationMap();
export const GENERATION_SELECTORS_TITLES_TRANSLATIONS_MAP = createTitlesTranslationMap();
